import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { CategoryLandingProps } from '../../../../containers/MergedStore/Category/CategoryLanding.types'
import { FC } from 'react'
import { Icon } from '@dtx-company/shared-components/src/components/atoms/Icon/index'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'

export const MergedStoreCategoryProductFeatures: FC<Pick<CategoryLandingProps, 'features'>> = ({
  features
}) => {
  return (
    <Box
      display={'grid'}
      gridTemplateColumns={{ _: '1fr', md: '1fr 1fr 1fr 1fr' }}
      gridRowGap={{ _: '20px', md: 0 }}
      maxWidth={{ _: '100%', md: '694px', lg: '1182px' }}
      width="100%"
      margin={'0 auto'}
    >
      {features?.map((item, idx) => (
        <Box
          flexDirection={{ _: 'row', md: 'column' }}
          justifyContent="center"
          alignItems={'center'}
          maxWidth={{ _: '100%', md: '154px', lg: '250px' }}
          key={`${item.title}-${idx}`}
        >
          <Icon
            src={item.icon?.url ?? ''}
            alt={item.icon?.alt ?? ''}
            width={{ _: '33px', md: '44px' }}
            height={{ _: '24px', md: '33px' }}
          />
          <Spacer mb={{ _: 0, md: '13px' }} mr={{ _: '24px', md: 0 }} />
          <Box flexDirection={'column'} alignItems={{ _: 'start', md: 'center' }}>
            <PrismicText
              richTextField={item.title}
              fontWeight={600}
              textAlign="center"
              maxWidth={{ _: '100%', md: '92px', lg: '100%' }}
            />
            <Spacer mb={'8px'} />
            <PrismicText
              richTextField={item.description}
              textAlign={{ _: 'left', md: 'center' }}
              maxWidth={{ _: '210px', md: '100%' }}
              fontSize={{ _: '12px', lg: '14px' }}
            />
          </Box>
        </Box>
      ))}
    </Box>
  )
}
